<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="box">
						<h2 class="box-caption">我的资金明细</h2>
						<div class="table-responsive">
							  <el-table
							    :data="tableData"
							    stripe
									border
							    style="width: 100%">
							    <el-table-column
							      prop="create_time"
							      label="日期"
							      width="200">
							    </el-table-column>
							    <el-table-column
							      prop="old_money"
							      label="原金额"
										width='190'>
							    </el-table-column>
							    <el-table-column
							      prop="money"
							      label="变动金额"
										width='190'>
							    </el-table-column>
									<el-table-column
									  label="变动后金额"
										width='190'
										>
										<template slot-scope="scope" >
											<span  class="text-success">{{scope.row.new_money}}</span> 
										</template>
									</el-table-column>
									<el-table-column label="备注" >
										<template slot-scope="scope">
											<span  class="text-red">{{scope.row.describe}}</span> 
										</template>
									</el-table-column>
							  </el-table>
						</div>
						<div class="text-right">
							    <el-pagination
							      @current-change="handleCurrentChange"
							      :current-page.sync="current_page"
							      :page-size="per_page"
							      layout="prev, pager, next, jumper,total"
										:page-count='last_page'
							      :total="total">
							    </el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				options: [{
					value: 11,
					label: '全部'
				}, {
					value: 12,
					label: '处理中'
				}, {
					value: 13,
					label: '待结算'
				}, {
					value: 14,
					label: '成功'
				}, {
					value: 15,
					label: '失败'
				}],
				delivery_status:{
					10:'处理中',
					20:'待结算',
					30:'成功',
					40:'失败',
					50:'待处理',
					60:'异常订单'
				},
				tableData: [],
				value2:[],
				dataFirst: '',
				dataLast:"",
				keyWord:"",
				current_page:1,
				last_page:10,
				per_page:10,
				total:100,
				orderType:11,
			}
		},
		created() {
			this.getOrder()
		},
		methods:{
			search(){
				this.getOrder()
			},
			empty(){
				this.keyWord = ''
				this.value2 = []
				this.dataFirst = ''
				this.dataLast = ''
				this.orderType = 11
				this.current_page = 1
				this.getOrder()
			},
			handleCurrentChange(val) {
				this.current_page = val
				this.getOrder()
			},
			optionData(){
				this.dataFirst = this.value2[0] + ' ' + '00:00:00'
				this.dataLast = this.value2[1] + " " + "23:59:59"
			},
			getOrder(){
				let token = localStorage.getItem('token')
				this.$api.getBalanceLog({
					token: token,
					type: this.orderType,
					page: this.current_page,
					start_time: this.dataFirst,
					end_time: this.dataLast,
					name: this.keyWord,
					category_name: ""
				}).then(res => {
					if(res.code === 1){
						console.log(res);
						this.current_page = res.data.list.current_page
						this.last_page = res.data.list.last_page
						this.per_page = res.data.list.per_page
						this.total = res.data.list.total

						this.tableData = res.data.list.data
					}else{
						
					}
				})
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/user/face_detail.vue